export default __webpack_public_path__ + "static/media/message-sent.bf5ee0cc.svg";